<template>
  <div
    v-if="!college"
    class="dashboard-card no-partner"
  >
    <h4>Your college isn’t currently a partner.</h4>
    <p>Contact us today and request your college to be added.</p>
    <router-link
      to="/contact"
      tag="button"
      class="btn btn-primary"
    >
      Contact Us
    </router-link>
  </div>
  <div
    v-else-if="college"
    class="dashboard-card partner-college"
  >
    <div
      v-if="college.banner_image"
      class="upper"
      :style="{ backgroundImage: `url(${college.banner_image.url})` }"
    />
    <div
      v-else
      class="upper default-banner"
    />

    <div
      v-if="college.logo"
      class="college-avatar"
      :style="{ backgroundImage: `url(${college.logo.url})` }"
    />
    <div
      v-else
      class="college-avatar default-avatar"
    />

    <div class="mid">
      <div class="row">
        <div class="col-12">
          <h2 style="font-size: 1.5rem">{{ college.name }}</h2>
        </div>
      </div>

      <div v-if="!college.is_member" class="row mb-2">
        <div class="col-12">
          <p>Unfortunately, you have no session credits available because your school is not currently partnered with BetterMynd</p>

          <p>Want to bring BetterMynd to your campus?</p>

          <button type="button" class="btn btn-primary btn-wide" @click="requestSchool()">Request your School</button>
        </div>
      </div>

      <div v-if="college.is_member && college.counseling_center_phone" class="row">
        <div
          class="col-12 info-block-section"
        >
          <div class="block">
            <div class="left">
              <div class="icon-container">
                <font-awesome-icon
                  :icon="['fas', 'phone']"
                  class="icon alt"
                />
              </div>
            </div>
            <div class="right">
              <b>Counseling Center</b>
              <a :href="college.counselingCenterPhoneHref">{{ college.counseling_center_phone }}</a>
            </div>
          </div>
        </div>
      </div>
      <!-- <p>Call the counseling center and press option 2 to speak with a counselor 24/7.</p> -->
      <!-- <div class="row mb-2" v-if="college.main_counselor_name">
        <div class="col-6">
          <b>{{college.main_counselor_name}}</b>
        </div>
        <div class="col-6 text-right" v-if="college.main_counselor_phone">
          <a :href="college.mainCounselorPhoneHref">{{college.main_counselor_phone}}</a>
        </div>
      </div> -->
      <!-- <p>On-Campus Counselor</p> -->
      <div v-if="college.is_member && (college.counseling_center_hours || college.counseling_center_location)" class="row">
        <div
          v-if="college.counseling_center_location"
          class="col-12 info-block-section"
        >
          <div class="block">
            <div class="left">
              <div class="icon-container">
                <font-awesome-icon
                  :icon="['fas', 'university']"
                  class="icon alt"
                />
              </div>
            </div>
            <div class="right">
              <b>Location</b>
              {{ college.counseling_center_location }}
            </div>
          </div>
        </div>
        <div
          v-if="college.counseling_center_hours"
          class="col-12 info-block-section"
        >
          <div class="block">
            <div class="left">
              <div class="icon-container">
                <font-awesome-icon
                  :icon="['fas', 'clock']"
                  class="icon alt"
                />
              </div>
            </div>
            <div class="right">
              <b>Location</b>
              {{ college.counseling_center_hours }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <request-school-modal ref="requestSchoolModal" />
  </div>
</template>

<script>
import RequestSchoolModal from '@/components/modals/RequestSchoolModal.vue';

export default {
  name: 'CollegeDashboardDisplay',
  components: {
    RequestSchoolModal,
  },
  props: {
    college: {
      type: Object,
    },
  },
  methods: {
    requestSchool() {
      this.$refs.requestSchoolModal.show();
    },
  },
};
</script>

<style lang="scss" scoped>
  .default-avatar {
    background-image: url('~@/assets/img/default-icon.jpg');
  }

  .default-banner {
    background-image: url('~@/assets/img/default-banner.jpg');
  }

  .info-block-section {
    .block {
      border-top: $default-border;
      padding-top: 15px;
      margin-top: 15px;
    }

    .icon-container {
      @include border-radius($border-radius);

      height: 45px;
      width: 45px;
      background: $green;
      text-align: center;
      line-height: 45px;
      font-size: 20px;
      color: $dark-blue;
    }

    .left {
      display: inline-block;
      vertical-align: top;
      width: 60px;
    }

    .right {
      display: inline-block;
      vertical-align: top;
      width: calc(100% - 60px);

      b {
        display: block;
      }
    }
  }
</style>
